import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Icon, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import { formatNumber, isNullUndefined, isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';
import moment from 'moment';
import { cloneDeep } from 'lodash-es';

function POWERBI_COMPONENT_TABLE(props) {
    const { t, i18n } = useTranslation();

    const { 
		inputParam_ComponentContent = null,
    	inputParam_UseFake = false,
    } = props;

    const [tableData, setTableData] = useState(!inputParam_UseFake ? inputParam_ComponentContent?.item : [{
        adminUsername: 'Borís Herrera',
        ing_contract: 'Miguel Olguín',
        segment: 'Crítico',
        contract_amount: '72 mill.',
        start_date: '202409',
        end_date: '202709',
        contact_term: '37',
        acceleration: 'Desacelerado',
        physical_progess: '19%',
        financial_process: '14%',
        expiration: '30-10-2026'
    }]);

    const getColorText = (value) => {
        let colorText = t('no-data');
        switch (value) {
            case 'r':
            colorText = t('data-lang-lbl-acelerated')
            break;
            case 'a':
            colorText = ""
            break;
            case 'v':
            colorText = ""
            break;
            default:
            colorText = t('no-data')
                break;
        }
        return colorText;
    }

    const getColor = (value) => {
        let color = "white";
        switch (value) {
            case 'r':
            color = "red"
            break;
            case 'a':
            color = "yellow"
            break;
            case 'v':
            color = "green"
            break;
            default:
            color = "white"
                break;
        }
        return color;
    }

    const esFechaDDMMYYYY = (str) => {
        const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
        const match = str.match(regex);
        if (!match) return false;

        const [ , dia, mes, anio ] = match;
        const fecha = new Date(`${anio}-${mes}-${dia}T00:00:00`);
        return (
            fecha.getFullYear() === parseInt(anio) &&
            fecha.getMonth() === parseInt(mes) - 1 &&
            fecha.getDate() === parseInt(dia)
        );
    }

    const getVencBG = (value) => {
        const exist = !isNullUndefinedOrEmpty(value);
        let vencBgObject = {text: t('no-data'), color: null};

        if (exist) {
            const isDate = esFechaDDMMYYYY(value);

            if (isDate) {
                const [day, month, year] = value.split('/').map(Number);
                const vencBGDate = new Date(year, month - 1, day);
                const today = new Date();

                today.setHours(0, 0, 0, 0);
                vencBGDate.setHours(0, 0, 0, 0);


                //r: vencida | a: 3 meses < vcto | v: 3meses > vcto
                
                const fechaInicialVencimiento = moment(cloneDeep(vencBGDate)).subtract(3, 'months').toDate();        

                vencBgObject.color = vencBGDate < today ? "red" : (today < fechaInicialVencimiento ? 'green' : 'orange');
                vencBgObject.text = value;
            }
            else {
                vencBgObject.text = value.length <= 10 ? value : value.substring(0, 10);
            }
        }

        return <>
            {
                !isNullUndefinedOrEmpty(vencBgObject.color) &&
                <Icon iconName='LocationFill' style={{color: vencBgObject.color}} />
            }
            <>{`${vencBgObject.text}`}</>
        </>;
    }

    return (<>
                <Card>
                    <table className="table mb-0 table-striped table-bordered table-sm">
                        <thead>
                            <tr className='text-center align-middle'>
                                <th className="p-0 m-0" style={{width: '14%'}}>{t('data-lang-lbl-adminusername')}</th>        
                                <th className="p-0 m-0" style={{width: '14%'}}>{t('data-lang-lbl-contracting')}</th>        
                                <th className="p-0 m-0" style={{width: '13%'}}>{t('data-lang-lbl-monthsegmentation')}</th>        
                                <th className="p-0 m-0" style={{width: '17%'}}>{`${t('data-lang-lbl-contractamount')} ${!isNullUndefinedOrEmpty(tableData) && tableData.length > 0 ? tableData[0].currencyExchange : t('no-data')}`}</th>        
                                <th className="p-0 m-0" style={{width: '17%'}}>{t('data-lang-lbl-exchangerate')}</th>        
                                <th className="p-0 m-0" style={{width: '8%'}}>{t('data-lang-lbl-startdate')}</th>        
                                <th className="p-0 m-0" style={{width: '8%'}}>{t('data-lang-lbl-termdate')}</th>        
                                <th className="p-0 m-0" style={{width: '9%'}}>{t('data-lang-lbl-contractterm')}</th>             
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !isNullUndefinedOrEmpty(tableData) && tableData.length > 0 && tableData.map((item, index) => (
                                    <tr key={index} className='text-center'>
                                        <td style={{maxWidth: "165px !important"}}>
                                            
                                            <TooltipHost content={ item.adminUsername }>
                                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <span>
                                                        { item.adminUsername }
                                                    </span>
                                                </div>
                                            </TooltipHost>
                                        </td>
                                        <td style={{maxWidth: "165px !important"}}>
                                            <TooltipHost content={ !isNullUndefined(item.l_props.find(x => x.shortName === "ingeniero_contrato")) ? item.l_props.find(x => x.shortName === "ingeniero_contrato").strVal : t('no-data') }>
                                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <span>
                                                        {!isNullUndefined(item.l_props.find(x => x.shortName === "ingeniero_contrato")) ? item.l_props.find(x => x.shortName === "ingeniero_contrato").strVal : t('no-data')}
                                                    </span>
                                                </div>
                                            </TooltipHost>
                                        </td>
                                        <td><span>{item.segmentName}</span></td>
                                        <td><span>{ isNullUndefinedOrEmpty(item.amountUSD) ? formatNumber(item.amount) : formatNumber(item.amountUSD) }</span></td>
                                        <td><span>{!isNullUndefined(item.rateExchange) ? item.rateExchange : t('no-data')}</span></td>
                                        <td><span>{moment(item.startDate).format('DD/MM/YYYY')}</span></td>
                                        <td><span>{moment(item.endDate).format('DD/MM/YYYY')}</span></td>
                                        <td><span>{item.nMesesContrato}</span></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </Card>
                <Card className='mt-2'>
                    <table className="table mb-0 table-striped table-bordered table-sm">
                        <thead>
                            <tr className='text-center align-middle'>   
                                <th className="p-0 m-0" style={{width: '25%'}}>{t('data-lang-lbl-aceleration')}</th>        
                                <th className="p-0 m-0" style={{width: '25%'}}>{t('data-lang-lbl-physicalprogress')}</th>        
                                <th className="p-0 m-0" style={{width: '25%'}}>{t('data-lang-lbl-financialprogress')}</th>        
                                <th className="p-0 m-0" style={{width: '25%'}}>{t('data-lang-lbl-vencbg')}</th>       
                            </tr>
                        </thead>
                        <tbody>
                            {
                                !isNullUndefinedOrEmpty(tableData) && tableData.length > 0 && tableData.map((item, index) => (
                                    <tr key={index} className='text-center'>
                                        <td><span><Icon iconName='LocationFill' style={{color: `${!isNullUndefined(item.l_gastos.find(x => x.key === "MTACEGASTO")) ? `${ getColor(item.l_gastos.find(x => x.key === "MTACEGASTO").item.color) }` : "grey"}`}} />{!isNullUndefined(item.l_gastos.find(x => x.key === "MTACEGASTO")) ? `${ getColorText(item.l_gastos.find(x => x.key === "MTACEGASTO").item.color) }` : t('no-data')}</span></td>
                                        <td><span>{!isNullUndefined(item.l_gastos.find(x => x.key === "MTAVANFISICO")) ? `${formatNumber(item.l_gastos.find(x => x.key === "MTAVANFISICO").item.valueGoalPercent)}%` : t('no-data')}</span></td>
                                        <td><span>{!isNullUndefined(item.l_gastos.find(x => x.key === "MTAVANFINAN")) ? `${formatNumber(item.l_gastos.find(x => x.key === "MTAVANFINAN").item.valueGoalPercent)}%` : t('no-data')}</span></td>
                                        <td><span>{getVencBG(!isNullUndefined(item.l_props.find(x => x.shortName.toLocaleString() === "boleta")) ? item.l_props.find(x => x.shortName.toLocaleString() === "boleta").strVal : null)}</span></td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </Card>
            </>);
}

POWERBI_COMPONENT_TABLE.propTypes = {
    inputParam_HideHeader: PropTypes.bool.isRequired,
    inputParam_ComponentContent: PropTypes.object.isRequired,
    inputParam_UseFake: PropTypes.bool.isRequired,
    inputParam_BoardStructure: PropTypes.object.isRequired,
    inputParam_Container: PropTypes.object.isRequired,
};

export default POWERBI_COMPONENT_TABLE;